export const PLATFORM_LOGIN_URL = '/app/developer';

export const CAPTCHA_CLIENT_SITE_KEY =
  '6LdY6DkUAAAAADQgB2MNeHGblu1EzzSjGm437aPQ';
export const CAPTCHA_CLIENT_REF = 'recaptcha';
export const CAPTCHA_REQUIRED_FIELD_ERROR = 'captcha_required';
export const EVENT_CAPTCHA_RENDERED = 'signup: captcha rendered';
export const EVENT_CAPTCHA_VERIFICATION_FAIL =
  'signup: captcha verification failed';

export const SIGNUP_FORM_BUTTON_COPY_AB_TEST_VARIANT = 'treatment';
export const SIGNUP_FORM_BUTTON_COPY_AB_TEST_NAME = 'signup-form-button-copy';
